import { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPlatform } from "../../../../helpers";
import { platformHandler } from "../../../../hooks/context";

const useRestockLogDetails = ({ selectedProduct }) => {
  const navigate = useNavigate();
  const { platform } = useContext(platformHandler);
  const { storeList, businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );

  const getVariantsList = (variants) => {
    if (!Array.isArray(variants)) return [];

    return variants
      .filter(
        (item) =>
          item?.variant?.id && item?.variant?.option && item?.variant?.value,
      )
      .map((item) => ({
        name: `${item.variant.option} - ${item.variant.value}`,
        id: item.variant.id,
      }));
  };

  const [variantsList] = useState(
    getVariantsList(selectedProduct?.restock_histories),
  );

  const handleViewSupplier = (id) => {
    navigate(`${getPlatform(platform)}/inventory/suppliers/${id}`);
  };

  return {
    variantsList,
    selectedProduct,
    storeList,
    businessDetails,
    handleViewSupplier,
  };
};

export default useRestockLogDetails;
